(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/password-recovery.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/password-recovery.js');
"use strict";


const {
  PageWrapper
} = svs.ticket_partner.sharedComponents.pageWrapper;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  LOGIN
} = svs.ticket_partner.constants.routes;
const {
  RecoveryEmailForm,
  PasswordRecoveryForm
} = svs.ticket_partner.passwordRecovery;
const {
  useState
} = React;
const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [restoreOptions, setRestoreOptions] = useState([]);
  const {
    redirectToReturnUrl
  } = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(LOGIN);
  const onRestoreOptionsChange = options => {
    setRestoreOptions(options);
  };
  const onRecoveySuccess = () => {
    setEmail('');
    setRestoreOptions([]);
    redirectToReturnUrl();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 5
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 10
  }, restoreOptions.length === 0 ? React.createElement(RecoveryEmailForm, {
    email: email,
    onEmailChange: e => setEmail(e.target.value),
    onRestoreOptionsChange: onRestoreOptionsChange
  }) : React.createElement(PasswordRecoveryForm, {
    email: email,
    onRecoveySuccess: onRecoveySuccess,
    restoreOptions: restoreOptions
  }))));
};
svs.ticket_partner.passwordRecovery.PasswordRecovery = PasswordRecovery;

 })(window);